import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { FULL_WIDTH_PAGE } from '@/shared/layouts/pageLayout';
import { DocumentTemplateCreate } from '../pages/DocumentTemplateCreate';
import { DocumentTemplateDetail } from '../pages/DocumentTemplateDetail';
import { DocumentTemplateList } from '../pages/DocumentTemplateList';

export const documentTemplatesRoutes: RouteObject[] = [
  {
    path: 'admin/document-templates',
    children: [
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'document_template', action: 'browse' }]} />,
        children: [{ index: true, element: <DocumentTemplateList /> }],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'document_template', action: 'add' }]} />,
        children: [{ path: 'new', element: <DocumentTemplateCreate /> }],
      },
      {
        element: <PermissionRoute requiredPermissions={[{ resource: 'document_template', action: 'read' }]} />,
        children: [{ path: ':id/:tab?', element: <DocumentTemplateDetail />, handle: FULL_WIDTH_PAGE }],
      },
    ],
  },
];
